import {
    ACCOUNT_MEMBER_SELECT_QUERY_RESET,
    ACCOUNT_MEMBER_SELECT_QUERY_SET_PARAMS,
    ACCOUNT_MEMBER_SELECT_QUERY,
    ACCOUNT_MEMBER_SELECT_QUERY_FAIL,
    ACCOUNT_MEMBER_SELECT_QUERY_SUCCESS,
} from './constants';

// ========================================================
// 查询成员
// ========================================================
export const queryAccountMemberSelectReset = () => ({
    type: ACCOUNT_MEMBER_SELECT_QUERY_RESET,
    payload: null,
});
export const queryAccountMemberSelectSetParams = ({params}) => ({
    type: ACCOUNT_MEMBER_SELECT_QUERY_SET_PARAMS,
    payload: {params},
});
export const queryAccountMemberSelect = ({params}) => ({
    type: ACCOUNT_MEMBER_SELECT_QUERY,
    payload: {params},
});
export const queryAccountMemberSelectSuccess = (data) => ({
    type: ACCOUNT_MEMBER_SELECT_QUERY_SUCCESS,
    payload: data,
});
export const queryAccountMemberSelectFail = (data) => ({
    type: ACCOUNT_MEMBER_SELECT_QUERY_FAIL,
    payload: data,
});
